<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-06-09 10:50:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-06-09 11:08:48
 * @FilePath: /WeMeet_admin_project/wemeet-admin/src/views/exhibitionManage/identity.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<!--
* @description:
* @fileName identity.vue
* @author hvv
* @date 2023/06/09 10:50:46
!-->
<template>
  <div style="padding: 20px">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-button type="success" @click="handleAdd">添加身份</el-button>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="signPeopleList">
      <el-table-column label="身份名称" prop="mobile" />
      <el-table-column label="身份背景图｜背景色" prop="type">
        <template #default="{ row }">
          <el-image fit="contain" :src="row.avatar" style="width: 50px; height: 50px; border-radius: 50%" />
        </template>
      </el-table-column>
      <el-table-column label="身份唯一Key" prop="name" />
      <el-table-column label="身份底部显示文字" prop="name" />
      <el-table-column label="状态">
        <template #default="{ row }">
          <el-tag v-if="row.status == 'SIGN_UP'" type="success">已报名</el-tag>
          <el-tag v-if="row.status == 'PARTICIPATE'">已参加</el-tag>
          <el-tag v-if="row.status == 'EXPIRED'" type="warning">已过期</el-tag>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <Edit ref="editRef" />
  </div>
</template>

<script>
  import { defineComponent, defineAsyncComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  export default defineComponent({
    name: 'identity.vue',
    components: {
      Edit: defineAsyncComponent(() => import('./components/editIdentity')),
    },
    setup(props, { emit }) {
      const state = reactive({
        editRef: null,
      })

      const handleAdd = () => {
        console.log(state.editRef)
        state.editRef.showEdit()
      }

      return {
        ...toRefs(state),
        handleAdd,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
